import type { EffectivePermissions, PermissionLevel } from './types';
import { FEATURE_KEYS } from './types';

const LEVEL_RANK: Record<PermissionLevel, number> = {
  none: 0,
  view: 1,
  edit: 2,
  delete: 3,
  admin: 4,
};

export function levelRank(level: PermissionLevel): number {
  return LEVEL_RANK[level] ?? 0;
}

export function hasAtLeast(effective: PermissionLevel, required: PermissionLevel): boolean {
  return levelRank(effective) >= levelRank(required);
}

export function hasDashboardAccess(effective: EffectivePermissions | undefined): boolean {
  if (!effective) return false;
  if (hasAtLeast(effective.dashboard, 'view')) return true;
  for (const k of FEATURE_KEYS) {
    if (k === 'dashboard') continue;
    if (hasAtLeast(effective[k], 'view')) return true;
  }
  return false;
}

export function defaultEffectivePermissions(): EffectivePermissions {
  const m = {} as EffectivePermissions;
  for (const k of FEATURE_KEYS) {
    m[k] = 'none';
  }
  return m;
}
